$(document).ready(function() {
    $(document).on('click', '.js-donation-checkbox', function() {
    	if($(this).find('input').prop('checked') == true) {
		    $(this).parents('.b-donation-form__form').find('.js-donation-button').prop('disabled', false);
		} else {
			$(this).parents('.b-donation-form__form').find('.js-donation-button').prop('disabled', true);
		}
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/promo/donation.js